import { createRoute } from '@tanstack/react-router'
import { Route as appLayoutRoute } from '@/app/layouts/app.layout.route'
import { ROUTES } from '@/shared/constants/routes'
import { FEATURE_FLAGS } from '@/shared/constants/feature-flags'
import { withFeatureGate } from '@/components/molecules'
import { DocumentsPage } from './page.documents'

export const Route = createRoute({
  getParentRoute: () => appLayoutRoute,
  path: ROUTES.DOCUMENTS,
  component: withFeatureGate(FEATURE_FLAGS.WEB_APP_DOCUMENTS, DocumentsPage),
})
